import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'partnerProfile',
  type: 'object',
  properties: {
    login: {
      type: 'string',
      title: 'Login Partnera (e-mail) *',
      fieldRequired: true
    },
    profile: {
      type: 'object',
      title: 'Profil',
      properties: {
        type: {
          title: 'Typ konta',
          type: 'number',
          fieldRequired: true
        },
        firstName: {
          title: 'Imię użytkownika',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        lastName: {
          title: 'Nazwisko użytkownika',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        email: {
          title: 'E-mail użytkownika (kontaktowy)',
          type: 'string',
          format: 'email'
        },
        phoneNumber: {
          title: 'Numer telefonu',
          type: 'string',
          maxLength: 500
        },
        companyName: {
          title: 'Nazwa Partnera *',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        companyPosition: {
          title: 'Stanowisko',
          type: 'string',
          maxLength: 500
        },
        mainImage: {
          title: 'Avatar',
          type: 'number'
        }
      }
    }
  }
};
